export default __webpack_public_path__ + "static/media/icon-withdrawn-fill.76551adb.svg";